(() => {
  if (window.__SeedyBulkPackStableV1) return;
  window.__SeedyBulkPackStableV1 = true;

  const VARIANT_CACHE = new WeakMap();

  const debounce = (fn, wait = 120) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  function safeParseVariants(container) {
    if (VARIANT_CACHE.has(container)) return VARIANT_CACHE.get(container);

    let data = [];
    try {
      data = JSON.parse(container.getAttribute("data-variants") || "[]");
    } catch (e) {
      data = [];
    }
    VARIANT_CACHE.set(container, data);
    return data;
  }

  function getPropertiesElements(container = document) {
    const elements = Array.from(container.querySelectorAll('[name^="properties["][name$="]"], [name^="_properties["][name$="]"]'));
    return elements.map((el) => {
      const match = el.name.match(/^(_?)properties\[(.*)\]$/);
      const isPrefixInactive = match ? match[1] === "_" : false;
      const property = match ? match[2] : "";

      return {
        type: el.tagName.toLowerCase(),
        element: el,
        property: property,
        isActive() {
          return !el.name.startsWith("_");
        },
        toggleActive(shouldActive) {
          const currentlyActive = this.isActive();
          if (shouldActive && !currentlyActive) {
            el.name = el.name.substring(1);
          } else if (!shouldActive && currentlyActive) {
            el.name = "_" + el.name;
          }
        },
        isHiddenProperty() {
          return this.property.startsWith("_");
        },
        isHiddenElement() {
          return el.type === "hidden";
        },
        toggleHidden(shouldHide) {
          const isHidden = this.isHiddenProperty();
          if (shouldHide && !isHidden) {
            this.property = "_" + this.property;
          } else if (!shouldHide && isHidden) {
            this.property = this.property.substring(1);
          }
          el.name = `properties[${this.property}]`;
        },
        toggleRequired(required) {
          if (required) {
            el.setAttribute("required", "required");
          } else {
            el.removeAttribute("required");
          }
        },
      };
    });
  }

  const VARIANT_0_NO_SELECTION = 0;
  const VARIANT_1_FLAVOURS = 1;
  const VARIANT_2_FLAVOURS = 2;
  const VARIANT_3_FLAVOURS = 3;
  const VARIANT_4_FLAVOURS = 4;

  function inferVariantFromLabel(label) {
    const raw = String(label || "").trim().toLowerCase();
    if (raw.startsWith("1 flavour (24 packs)")) return VARIANT_1_FLAVOURS;
    if (raw.startsWith("2 flavours (12 packs each)")) return VARIANT_2_FLAVOURS;
    if (raw.startsWith("3 flavours (8 packs each)")) return VARIANT_3_FLAVOURS;
    if (raw.startsWith("4 flavours (6 packs each)")) return VARIANT_4_FLAVOURS;
    return null; // unknown -> do nothing
  }

  function getVariantIdFromUrl() {
    try {
      return new URL(window.location.href).searchParams.get("variant");
    } catch (e) {
      return null;
    }
  }

  function findAddToCartButton(form) {
    return (
      form.querySelector('button[name="add"]') ||
      form.querySelector('button[type="submit"][name="add"]') ||
      form.querySelector('button[type="submit"]')
    );
  }

  function setButtonEnabled(form, enabled) {
    const btn = findAddToCartButton(form);
    if (!btn) return;

    // Only toggle if the theme isn't force-disabling for other reasons
    btn.disabled = !enabled;
    btn.setAttribute("aria-disabled", (!enabled).toString());
    if (!enabled) btn.classList.add("disabled");
    else btn.classList.remove("disabled");
  }

function validateFlavours(container, count) {
  if (count === 0) return { ok: true };

  const visibleFields = Array.from(container.querySelectorAll("[data-bulk-pack-field]"))
    .filter((f) => f.style.display !== "none");

  const selects = visibleFields.map((f) => f.querySelector("select")).filter(Boolean);
  const chosen = selects.map((s) => (s.value || "").trim()).filter(Boolean);

  // all required must be selected
  if (chosen.length !== selects.length) return { ok: false, reason: "missing" };

  // ✅ Allow duplicates for the 3-flavour option only
  if (count !== 3) {
    if (new Set(chosen).size !== chosen.length) return { ok: false, reason: "duplicates" };
  }

  return { ok: true };
}


  function showError(container, msg) {
    const err = container.querySelector("[data-bulk-pack-error]");
    if (!err) return;
    if (!msg) {
      err.style.display = "none";
      err.textContent = "";
      return;
    }
    err.style.display = "block";
    err.textContent = msg;
  }

  function toVariantInfo(v) {
    if (!v) return null;
    const label = (v.option1 || v.title || "").toLowerCase();

    let bulk_pack_variant = 0;
    let bulk_pack_hint = "";

    if (label.includes("1 flavour")) {
      bulk_pack_variant = VARIANT_1_FLAVOURS;
      bulk_pack_hint = "Choose 1 flavour (24 packs).";
    } else if (label.includes("2 flavour")) {
      bulk_pack_variant = VARIANT_2_FLAVOURS;
      bulk_pack_hint = "Choose 2 flavours (12 packs each).";
    } else if (label.includes("3 flavour")) {
      bulk_pack_variant = VARIANT_3_FLAVOURS;
      bulk_pack_hint = "Choose 3 flavours (8 packs each).";
    } else if (label.includes("4 flavour")) {
      bulk_pack_variant = VARIANT_4_FLAVOURS;
      bulk_pack_hint = "No flavour selection needed for this option.";
    } else {
      bulk_pack_variant = VARIANT_1_FLAVOURS;
      bulk_pack_hint = "Choose 1 flavour.";
    }

    return { bulk_pack_variant, bulk_pack_hint };
  }

  function setChooseFlavourFields(container, variantInfo) {
    const count = variantInfo.bulk_pack_variant;
    const fields = Array.from(container.querySelectorAll("[data-bulk-pack-field]"));
    const props = getPropertiesElements(container);

    fields.forEach((field) => {
      const idx = Number(field.getAttribute("data-index"));
      const shouldBeVisible = count > 0 && count < 4 && idx <= count;
      field.style.display = shouldBeVisible ? "" : "none";
    });

    props.forEach((p) => {
      if (p.property.toLowerCase().startsWith("flavour") || (p.property.startsWith("_") && p.property.toLowerCase().startsWith("_flavour"))) {
        const match = p.property.match(/Flavour (\d+)/i);
        if (match) {
          const idx = Number(match[1]);
          const shouldShow = count > 0 && count < 4 && idx <= count;
          p.toggleActive(shouldShow);
          p.toggleRequired(shouldShow);

          if (!shouldShow && p.element.tagName.toLowerCase() === "select") {
            p.element.value = "";
          }
        }
      }
    });
  }

  function setPageVariant(container, v, variant, variantInfo) {
    const variantInput = document.querySelector('input[name="id"][ref="variantId"]');
    if (variantInput && v && v.id) {
      variantInput.value = v.id;
    }

    const hintEl = container.querySelector("[data-bulk-pack-hint]");
    if (hintEl) hintEl.textContent = variantInfo.bulk_pack_hint;

    if (variantInfo.bulk_pack_variant === VARIANT_4_FLAVOURS) {
      container.style.display = "none";
    } else {
      container.style.display = "";
    }

    setChooseFlavourFields(container, variantInfo);
    showError(container, "");
  }

  function refreshContainer(container) {
    const form = container.closest('form[action*="/cart/add"], form[action*="cart/add"]');
    if (!form) return;

    const variants = safeParseVariants(container);
    if (!variants.length) return;

    const vid = getVariantIdFromUrl();
    if (!vid) return;

    const v = variants.find((x) => String(x.id) === String(vid));
    if (!v) return;

    const variantInfo = toVariantInfo(v);
    if (!variantInfo) return;

    const variant = variantInfo.bulk_pack_variant;

    setPageVariant(container, v, variant, variantInfo);

    const check = validateFlavours(container, variant);
if (!check.ok) {
  showError(
    container,
    check.reason === "missing"
      ? "Please select all required flavours."
      : "Please choose different flavours."
  );
} else {
  showError(container, "");
}


    const canBuy = Boolean(v.available) && check.ok;
    setButtonEnabled(form, canBuy);
  }

  const scanAndRefresh = () => {
    document.querySelectorAll("[data-bulk-pack-flavours]").forEach(refreshContainer);
  };

  const scanAndRefreshDebounced = debounce(scanAndRefresh, 120);

  // URL change detection (Savor uses history API)
  const _pushState = history.pushState;
  const _replaceState = history.replaceState;

  history.pushState = function () {
    _pushState.apply(this, arguments);
    window.dispatchEvent(new Event("seedy:urlchange"));
  };
  history.replaceState = function () {
    _replaceState.apply(this, arguments);
    window.dispatchEvent(new Event("seedy:urlchange"));
  };

  window.addEventListener("popstate", () => window.dispatchEvent(new Event("seedy:urlchange")));
  window.addEventListener("seedy:urlchange", () => {
    // allow theme to settle, then refresh
    scanAndRefreshDebounced();
    setTimeout(scanAndRefreshDebounced, 120);
  });

  // When user changes flavour selects
  document.addEventListener(
    "change",
    (e) => {
      if (e.target && e.target.matches && e.target.matches("[data-flavour-select]")) {
        scanAndRefreshDebounced();
      }
    },
    true
  );

  // DOM changes: throttle heavily
  const mo = new MutationObserver(() => scanAndRefreshDebounced());
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // initial
  scanAndRefreshDebounced();
})();
